import React, { useRef } from 'react';
import AboutHeroSection from '../components/landingPage/AboutUsPage/AboutHeroSection';
import AboutWhyExistSection from '../components/landingPage/AboutUsPage/AboutWhyExistSection';
import AboutTeamSlider from '../components/landingPage/AboutUsPage/AboutTeamSlider';
import AboutAdvisorySlider from '../components/landingPage/AboutUsPage/AboutAdvisorySlider';
import AboutQuotesSection from '../components/landingPage/AboutUsPage/AboutQuotesSection';
import AboutCtaSection from '../components/landingPage/AboutUsPage/AboutCtaSection';
import { useReveal, useCountUp } from '../components/landingPage/common/landingHooks';

const AboutUs = () => {
    const rootRef = useRef(null);
    useReveal(rootRef);
    useCountUp(rootRef);

    return (
        <div className="lp-page" ref={rootRef}>
            <AboutHeroSection />
            <AboutWhyExistSection />
            <AboutTeamSlider />
            <AboutAdvisorySlider />
            {/* <AboutQuotesSection /> */}
            <AboutCtaSection />
        </div>
    );
};

export default AboutUs;
